import { inject } from '@vue/composition-api';

export const INJECTION_STORE_KEY = Symbol('vuex-store-key');

export function useStore() {
  return inject(INJECTION_STORE_KEY);
}
